import { ReportStudioElementMetadata } from '@/modules/ta/reportstudio/models/ReportStudioElementMetadata';
import { TextDesignOption } from '@/modules/ta/reportstudio/models/element/metadata/TextDesignOption';
import { ReportElementDesignOption } from '@/modules/ta/reportstudio/reportstudio.constants';

export class ReportStudioTextElementMetadata extends ReportStudioElementMetadata {
  constructor(model = {}) {
    super(model);
    this.macro_type = model.macro_type;
    this.design_options = new TextDesignOption(model.design_options);
  }

  isTextBold() {
    return this.design_options.text_bold;
  }

  isTextItalic() {
    return this.design_options.text_italic;
  }

  isTextUnderline() {
    return this.design_options.text_underline;
  }

  isTextStrikeThrough() {
    return this.design_options.text_strikethrough;
  }

  isTextLeftAligned() {
    return this.design_options.text_align === ReportElementDesignOption.TEXT_ALIGNMENT.LEFT;
  }

  isTextRightAligned() {
    return this.design_options.text_align === ReportElementDesignOption.TEXT_ALIGNMENT.RIGHT;
  }

  isTextCenterAligned() {
    return this.design_options.text_align === ReportElementDesignOption.TEXT_ALIGNMENT.CENTER;
  }

  isTextJustifyAligned() {
    return this.design_options.text_align === ReportElementDesignOption.TEXT_ALIGNMENT.JUSTIFY;
  }
}
